export const USER_PERMISSION_SUPER = "super";
export const USER_PERMISSION_ADMIN = "admin";
export const USER_PERMISSION_NORMAL = "normal";
export const USER_PERMISSION_LIMITED = "limited";
export const USER_PERMISSION_NONE = "none";
export const USER_PERMISSION_CAN_GIVE_BONSUSES = "canGiveBonuses";
export const USER_PERMISSION_CAN_SEE_RECRUITS_INFO = "canSeeRecruitsInfo";
